import { useEffect } from "react";

import { PricingContentContextProvider } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { LoomPricingPage as LoomPricingPageTemplate } from "@/templates/software/loom/pricing/loom-pricing-page.template.tsx";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../contentful/index.tsx";

export interface LoomPricingPageProps {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
}

export const LoomPricingPage = (props: LoomPricingPageProps) => {
    const { pricingContent, pricing, countryCode } = props;

    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProvider
            productId="loom"
            pricingContent={pricingContent}
        >
            <LoomPricingPageTemplate />
        </PricingContentContextProvider>
    );
};
